import { z } from "zod";

// Validation schemas -- projected from spec domain model

export const createOrganizationSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  type: z.enum(["platform", "school", "club"]),
  parent_org_id: z.string().nullable().optional(),
});

export const updateOrganizationSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  type: z.enum(["platform", "school", "club"]),
  parent_org_id: z.string().nullable().optional(),
});

export type CreateOrganizationInput = z.infer<typeof createOrganizationSchema>;
export type UpdateOrganizationInput = z.infer<typeof updateOrganizationSchema>;
